'use client'

export const Stamp = (props: { text?: string }) => {
  if (!props.text) return null

  return (
    <div className="rounded-[4px] bg-bodi-green-bright-500 px-1 font-sans text-[11px] font-semibold leading-5 text-bodi-black-text">
      {props.text}
    </div>
  )
}
